import gql from 'graphql-tag';

export const CREATIVE_VIDEOS = gql`
  query CreativeVideos($articleGroupId: String!) {
    creativeVideos(articleGroupId: $articleGroupId) {
      videos {
        id
        picture
        source
        title
        videoSource
      }
      errors
    }
  }
`;
